import * as de from '../../../../../../config/locales/js/de.json';
angular.module('cerego.translate').constant('translateDe', de);
